import tachyons from '@/tachyons'

tachyons.input = 'input-reset w-100 pa2 bg-white ba b--moon-gray bg-dark-gray br2';
tachyons.commonLabel = 'pb3 etiqueta';
tachyons.formErrors = 'f7 form-errors';
tachyons.formHelp = 'mh2 ph1 f7';

tachyons.button = 'w4 f5 link ph2 pv2 mb2 black-90 ba bg-white br-pill';

tachyons.secondary = 'w4 f5 link ph2 pv2 mb2 white bg-silver br-pill';

export default tachyons
